import React from "react";
const OfficeHierarchyView = ({ data }) => {
  return (
    <div className="w-full space-y-2">
      <div className="grid xl:grid-cols-2 lg1:grid-cols-2 text-xs px-10  py-2  gap-y-1 md:grid-cols-2 sm:grid-cols-1">
        <div className="gap-2">
          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">
              Hierarchy Effective Date:
            </label>
            <div className="expandedData fontExpand">
              {data?.officeHierarchyEffectiveDate === null ||
              data?.officeHierarchyEffectiveDate === "1970-01-01T00:00:00"
                ? null
                : data.officeHierarchyEffectiveDate
                ? new Date(
                    data.officeHierarchyEffectiveDate
                  ).toLocaleDateString()
                : null}
            </div>
          </div>
          <div className="grid grid-cols-2 py-1 border-b border-gray-200">
            <label className="expandedLabel fontExpand">Branch Manager:</label>
            <div className="expandedData fontExpand">
              {data?.branchManagerName}
            </div>
          </div>
        </div>
        <div className="gap-2">
          {data?.officeType?.toLowerCase() !== "franchise" && (
            <div className="grid grid-cols-2 py-1 border-b border-gray-200">
              <label className="expandedLabel fontExpand">
                HR Business Partner:
              </label>

              <div className="expandedData fontExpand">
                {data?.hrBusinessPartner}
              </div>
            </div>
          )}
        </div>
        <div className="gap-2">
          {data?.officeType?.toLowerCase() === "franchise" && (
            <div className="grid grid-cols-2 py-1 border-b border-gray-200">
              <label className="expandedLabel fontExpand">
                Business Consultant:
              </label>

              <div className="expandedData fontExpand">
                {data?.businessConsultantName}
              </div>
            </div>
          )}
          {data?.officeType?.toLowerCase() === "franchise" && (
            <div className="grid grid-cols-2 py-1 border-b border-gray-200">
              <label className="expandedLabel fontExpand">
                Franchise Owner:
              </label>
              <div className="expandedData fontExpand">
                {data?.franchiseOwner}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="grid xl:grid-cols-2 lg1:grid-cols-2 text-xs px-10 py-2 gap-y-6 md:grid-cols-2 sm:grid-cols-1">
        <div className="gap-2">
          <div className="grid grid-cols-2 py-1 border-b border-gray-200">
            <label className="expandedLabel fontExpand">District Name:</label>
            <div className="expandedData fontExpand">{data?.districtName}</div>
          </div>

          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">District Code:</label>
            <div className="expandedData fontExpand">{data?.districtCode}</div>
          </div>
          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">
              District Manager:
            </label>
            <div className="expandedData fontExpand">
              {data?.districtManager}
            </div>
          </div>
        </div>

        <div className="gap-2">
          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">Region Name:</label>
            <div className="expandedData fontExpand">{data?.regionName}</div>
          </div>
          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">Region Code:</label>
            <div className="expandedData fontExpand">{data?.regionCode}</div>
          </div>
        </div>
        <div className="gap-2">
          <div className="grid grid-cols-2 py-1 border-b border-gray-200">
            <label className="expandedLabel fontExpand">Area Name:</label>
            <div className="expandedData fontExpand">{data?.areaName}</div>
          </div>
          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">Area Code:</label>
            <div className="expandedData fontExpand">{data?.areaCode}</div>
          </div>
          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">Sales VP:</label>
            <div className="expandedData fontExpand">{data?.salesVp}</div>
          </div>
        </div>
        <div className="gap-2">
          <div className="grid grid-cols-2 py-1 border-b border-gray-200">
            <label className="expandedLabel fontExpand">Territory Name:</label>
            <div className="expandedData fontExpand">{data?.territoryName}</div>
          </div>
          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">Territory Code:</label>
            <div className="expandedData fontExpand">{data?.territoryCode}</div>
          </div>
          <div className="grid grid-cols-2 py-1 border-b border-gray-200 ">
            <label className="expandedLabel fontExpand">Sales President:</label>
            <div className="expandedData fontExpand">
              {data?.salesPresident}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficeHierarchyView;
